import AutoCompletePicker from './AutoCompletePicker';

export default AutoCompletePicker;
export type { IAutoCompletePickerProps } from './AutoCompletePicker';
